import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

const PANEL_ID = 'poster-editor-draw-brush-panel';

export default function PosterEditorDrawBrushModal(): ReactElement<any> {
  const height = '165px';
  const maxWidth = '900px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_DRAW_BRUSH_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="poster-editor-draw-brush-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorDrawBrushModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_DRAW_BRUSH_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
